export const getUpgradeBasketAttributes = (element: Element) => {
  const orderId = element.getAttribute("data-basket-previous-order-id");
  const previousAreaId = element.getAttribute("data-basket-previous-area-id");
  const areaId = element.getAttribute("data-basket-area-id");
  return { orderId, previousAreaId, areaId };
};
